import { http } from "../http-common";
import { Professional } from "../models/Professional";

class ProfessionalDataService {
    async getAll() {
        return await http().get<Array<Professional>>("/professionals");
    }
}
export default new ProfessionalDataService();